import React, { useState } from 'react';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
  FreeMode,
} from 'swiper';
import NextButtonIcon from '../../kit/icons/NextButtonIcon';
import 'swiper/css';
import { styles } from './styles';

const positions = {
  onSides: 'onSides',
  top: 'top',
  bottom: 'bottom',
};

export default function SwiperComponent({
  slides,
  NavigateButton = NextButtonIcon,
  navigatePosition = 'bottom',
  slidesPerView,
  isMobileFullsize = true,
  shiftNavigate,
  hideNavigate = false,
  ...rest
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [swiper, setSwiper] = useState(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const isFinite = !rest.loop;
  const isNavigateVisible =
    !hideNavigate &&
    (swiper ? swiper?.slides?.length > swiper?.params?.slidesPerView : !isSm);
  const navigateMargin =
    navigatePosition === 'bottom'
      ? '0 0 -54px'
      : navigatePosition === 'top'
        ? '-100px 0 0'
        : 0;
  return (
    <Box
      sx={(theme) =>
        styles.root(
          theme,
          isMobileFullsize,
          swiper?.slides?.length && shiftNavigate && navigateMargin,
        )
      }
    >
      {!isSm && isNavigateVisible && navigatePosition === positions.top && (
        <Box sx={(_) => styles.buttonBlock(_, navigatePosition)}>
          <Box sx={(_) => styles.buttonSlidePrev(_, isFinite, isBeginning)}>
            <IconButton onClick={() => swiper && swiper.slidePrev()}>
              <NavigateButton />
            </IconButton>
          </Box>
          <Box sx={(_) => styles.buttonSlideNext(_, isFinite, isEnd)}>
            <IconButton onClick={() => swiper && swiper.slideNext()}>
              <NavigateButton />
            </IconButton>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        {!isSm &&
          isNavigateVisible &&
          navigatePosition === positions.onSides && (
            <Box sx={(_) => styles.buttonSlidePrev(_, isFinite, isBeginning)}>
              <IconButton onClick={() => swiper && swiper.slidePrev()}>
                <NavigateButton />
              </IconButton>
            </Box>
          )}
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            '& > .swiper-initialized': {
              padding: {
                xs: isMobileFullsize ? '12px 16px 8px 16px' : 0,
                xl: isMobileFullsize ? '12px 8px 8px 8px' : 0,
              },
            },
            '& .swiper-slide': {
              height: 'auto',
            },
            '& .swiper-slide-active': {
              zIndex: 1,
            },
          }}
        >
          <>
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                backgroundColor: '#f3f1f8',
                borderRadius: 3,
                opacity: swiper ? 0 : 1,
                zIndex: swiper ? 0 : 2,
              }}
            />
            {slides && (
              <Swiper
                modules={[
                  Autoplay,
                  Navigation,
                  Pagination,
                  Scrollbar,
                  A11y,
                  FreeMode,
                ]}
                slidesPerView={slidesPerView}
                onSwiper={(swiper) => {
                  setSwiper(swiper);
                }}
                onSlideChange={(sw) => {
                  setIsBeginning(sw.isBeginning);
                  setIsEnd(sw.isEnd);
                }}
                {...rest}
              >
                {rest.children}
                {slides.map((Slide, i) => (
                  <SwiperSlide key={`swiper-slide-${i}`}>
                    <Slide />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </>
        </Box>
        {!isSm && isNavigateVisible && navigatePosition === 'onSides' && (
          <Box sx={(_) => styles.buttonSlideNext(_, isFinite, isEnd)}>
            <IconButton onClick={() => swiper && swiper.slideNext()}>
              <NavigateButton />
            </IconButton>
          </Box>
        )}
      </Box>
      {!isSm && isNavigateVisible && navigatePosition === positions.bottom && (
        <Box sx={styles.buttonBlock}>
          <Box sx={(_) => styles.buttonSlidePrev(_, isFinite, isBeginning)}>
            <IconButton onClick={() => swiper && swiper.slidePrev()}>
              <NavigateButton />
            </IconButton>
          </Box>
          <Box sx={(_) => styles.buttonSlideNext(_, isFinite, isEnd)}>
            <IconButton onClick={() => swiper && swiper.slideNext()}>
              <NavigateButton />
            </IconButton>
          </Box>
        </Box>
      )}
    </Box>
  );
}
